import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@hm/environments/environment';

import { DoctorProfile, PersonalDoctorService } from '@lib/core/models/doctor.interface';

@Injectable({ providedIn: 'root' })
export class DoctorsService {
  private readonly http = inject(HttpClient);

  getDoctors() {
    return this.http.get<DoctorProfile[]>(`${environment.healthManagerApiUrl}/doctors`);
  }

  getPersonalDoctors() {
    return this.http.get<DoctorProfile[]>(`${environment.healthManagerApiUrl}/personal-doctors`);
  }

  updatePersonalDoctor(memberId: string, doctorId: string): Observable<unknown> {
    return this.http.put<unknown>(`${environment.healthManagerApiUrl}/members/${memberId}/personal-doctor`, {
      doctorId,
    });
  }

  getPersonalDoctorServices() {
    return this.http.get<PersonalDoctorService[]>(`${environment.healthManagerApiUrl}/personal-doctors/services`);
  }
}
